<template>
  <div class="mgl-10px">
  <div class="card-article-input-selectDateVente columns is-vcentered">
    <div class="has-text-centered is-paddingless"
         :class="[datePickerStyle.datePickerColor,
         {'disabled' : disabled}]">
      <a @click="showModalChangeDateLocation = true">
        <b-icon
          :icon="datePickerStyle.calendarIcon"
          type="is-white"
          custom-class="mgt-10px">
        </b-icon>
      </a>
    </div>
    <div class="card-article-input-dateRegroup has-text-icon-more
      is-size-7 column is-narrow is-paddingless"
         :class="datePickerStyle.colorDate">
        {{ getDate }}
    </div>
    <div class="card-article-input-dayRegroup
    has-text-icon-more is-size-7" v-if="getNumberDay">
      {{ $t('detail.article.numberDays', { nbJour: getNumberDay }) }}
      <span v-if="ligneRegroupement.typeProduit === produitRegroupement">
        <br />
        {{ $t('detail.article.week',
          { week: ligneRegroupement.ligneReseau.anneeSemaine.toString().substr(4,6)})
        }}
      </span>
    </div>
    <b-modal v-model="showModalChangeDateLocation" has-modal-card class="modal">
      <pop-up-change-date-location-produit-reseau v-if=isReseau
        :ligneRegroupement="ligneRegroupement" :devisCommande="devisCommande"
        @updatePeriodeLocation="updatePeriodeLocation"/>
      <pop-up-change-date-location-produit v-else class="max-width-750 width-750"
        :ligneRegroupement="ligneRegroupement" :devisCommande="devisCommande"
                                           :avecMajDateRenouvellement="devisCommande.renouvelable"
        @updatePeriodeLocation="updatePeriodeLocation"/>
    </b-modal>
  </div>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import formatDate from '@/services/general/formatDate';
import * as produitConf from '@/configuration/catalogue/produitConf';
import { COMMANDER, AFFECTER_DANS_RESEAU } from '@/configuration/affectation/affectationConf';
import { TYPE_DEVIS, REGROUPEMENT, TYPE_COMMANDE } from '@/configuration/devisConf';
import calculDaysBetweenTwoDate from '@/services/general/calculDaysBetweenTwoDate';
import aEncoreQuantiteDispo from '@/services/devisCommandes/aEncoreQuantiteDispo';
import { GUID_VIDE } from '@/configuration/general';
import popUpChangeDateLocationProduit from './popUpChangeDateLocationProduit';
import popUpChangeDateLocationProduitReseau from './popUpChangeDateLocationProduitReseau';

export default {
  props: {
    ligneRegroupement: Object,
    devisCommande: Object,
    ouverturePopup: Boolean,
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    popUpChangeDateLocationProduitReseau,
    popUpChangeDateLocationProduit,
  },
  computed: {
    isLigneRegroupementReseauInCreateCommandeFromDevis() {
      return (this.devisCommande.type === TYPE_COMMANDE
        && this.devisCommande.id === GUID_VIDE
        && this.devisCommande.referenceId
        && this.ligneRegroupement.typeProduit === produitConf.CATEGORIE_REGROUPEMENT
        && this.ligneRegroupement.type === REGROUPEMENT);
    },
    getNumberDay() {
      const dateDebut = this.ligneRegroupement.dateDebut;
      const dateFin = this.ligneRegroupement.dateFin;
      if (dateDebut && dateFin) return Number(calculDaysBetweenTwoDate(dateFin, dateDebut)) + 1;
      return null;
    },
    datePickerStyle() {
      if (this.isLigneRegroupementReseauInCreateCommandeFromDevis || this.disabled) {
        return { datePickerColor: { 'card-article-input-datepicker-disabled disabled': true }, calendarIcon: 'calendar-clock' };
      }
      if (this.ligneRegroupement.typeProduit === produitConf.CATEGORIE_UNITAIRE
        && !this.ligneRegroupement.produit.actif) {
        return { datePickerColor: { 'card-article-input-datepicker-warning': true }, colorDate: { 'has-text-warning': true }, calendarIcon: 'calendar-alert' };
      }
      if (!this.ligneRegroupement.affectation
        || this.ligneRegroupement.affectation.length === 0
        || aEncoreQuantiteDispo(this.ligneRegroupement.affectation,
          this.ligneRegroupement.quantiteDispo, this.devisCommande.type)) {
        return { datePickerColor: { 'card-article-input-datepicker-success': true }, calendarIcon: 'calendar-clock' };
      }
      if (!this.ligneRegroupement.dateDebut && !this.ligneRegroupement.dateFin) return { datePickerColor: { 'card-article-input-datepicker-empty': true }, calendarIcon: 'calendar-clock' };
      if (this.ligneRegroupement.produit.controleDisponibilite
          && this.ligneRegroupement.affectation.some((produitAffecte) => {
            return produitAffecte.typeReference === COMMANDER;
          })) {
        if (this.devisCommande.type === TYPE_DEVIS) return { datePickerColor: { 'card-article-input-datepicker-warning': true }, colorDate: { 'has-text-warning': true }, calendarIcon: 'calendar-remove' };
        return { datePickerColor: { 'card-article-input-datepicker-danger': true }, colorDate: { 'has-text-danger': true }, calendarIcon: 'calendar-remove' };
      }
      if (this.ligneRegroupement.affectation.some((produitAffecte) => {
        return produitAffecte.typeReference === AFFECTER_DANS_RESEAU;
      })) return { datePickerColor: { 'card-article-input-datepicker-warning': true }, colorDate: { 'has-text-warning': true }, calendarIcon: 'calendar-alert' };
      return { datePickerColor: { 'card-article-input-datepicker-success': true }, calendarIcon: 'calendar-clock' };
    },
    getDate() {
      switch (this.ligneRegroupement.typeProduit) {
        case produitConf.CATEGORIE_UNITAIRE: return this.getDateUnitaire;
        case produitConf.CATEGORIE_REGROUPEMENT: return this.getDateSemaine;
        case produitConf.CATEGORIE_REGROUPEMENT_LC: return this.getDateReseauLc;
        case produitConf.CATEGORIE_REGROUPEMENT_NUMERIQUE:
        case produitConf.CATEGORIE_ECRAN_NUMERIQUE:
          return this.getDateGeneral;
        default: return '';
      }
    },
    getDateSemaine() {
      return this.$t('detail.article.date', {
        dateDebut: formatDate(this.ligneRegroupement.dateDebut),
        dateFin: formatDate(this.ligneRegroupement.dateFin),
      });
    },
    getDateUnitaire() {
      if (!this.ligneRegroupement.dateDebut || !this.ligneRegroupement.dateFin) return this.$t('dateDevis.pasDate');
      if (!this.ligneRegroupement.produit.actif) return this.$t('detail.article.produitArchive');
      if (!aEncoreQuantiteDispo(this.ligneRegroupement.affectation,
        this.ligneRegroupement.quantiteDispo, this.devisCommande.type)) {
        if (this.ligneRegroupement.affectation.some((produitAffecte) => {
          return produitAffecte.typeReference === COMMANDER;
        })) return this.$t('detail.article.indisponible');
        if (this.ligneRegroupement.affectation.some((produitAffecte) => {
          return produitAffecte.typeReference === AFFECTER_DANS_RESEAU;
        })) return this.$t('detail.article.dejaAffecter');
      }
      return this.$t('detail.article.date', { dateDebut: formatDate(this.ligneRegroupement.dateDebut), dateFin: formatDate(this.ligneRegroupement.dateFin) });
    },
    getDateReseauLc() {
      if (!this.ligneRegroupement.dateDebut || !this.ligneRegroupement.dateFin) return this.$t('dateDevis.pasDate');
      if (!this.ligneRegroupement.produit.actif) return this.$t('detail.article.produitArchive');
      if (!aEncoreQuantiteDispo(this.ligneRegroupement.affectation,
        this.ligneRegroupement.quantiteDispo, this.devisCommande.type)) {
        if (this.ligneRegroupement.affectation.some(el => el.typeReference === COMMANDER)) return this.$t('detail.article.indisponible');
      }
      return this.$t('detail.article.date', { dateDebut: formatDate(this.ligneRegroupement.dateDebut), dateFin: formatDate(this.ligneRegroupement.dateFin) });
    },
    getDateGeneral() {
      if (this.ligneRegroupement.typeProduit === produitConf.CATEGORIE_REGROUPEMENT_LC
        && this.ligneRegroupement.affectation.some((produitAffecte) => {
          return produitAffecte.typeReference === COMMANDER;
        })) return this.$t('detail.article.indisponible');
      if (!this.ligneRegroupement.dateDebut) return '';
      if (!this.ligneRegroupement.dateFin) {
        return this.$t('detail.article.dateDebut', { dateDebut: formatDate(this.ligneRegroupement.dateDebut) });
      }
      return this.$t('detail.article.date', { dateDebut: formatDate(this.ligneRegroupement.dateDebut), dateFin: formatDate(this.ligneRegroupement.dateFin) });
    },
    isReseau() {
      return this.ligneRegroupement.typeProduit === produitConf.CATEGORIE_REGROUPEMENT;
    },
  },
  methods: {
    transformDate(date) {
      return formatDate(date);
    },
    updatePeriodeLocation(eventArgument) {
      this.$emit('updatePeriodeLocation', eventArgument);
    },
  },
  data() {
    return {
      showModalChangeDateLocation: false,
      produitRegroupement: produitConf.CATEGORIE_REGROUPEMENT,
    };
  },
  mounted() {
    this.showModalChangeDateLocation = cloneDeep(this.ouverturePopup);
  },
};
</script>

<style scoped>

</style>
